<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.889"
    height="14"
    viewBox="0 0 10.889 14"
    class="scaling-svg"
    transform="rotate(180)"
  >
    <path
      d="M5.444,0a.794.794,0,0,0-.778.81V8.524L1.386,5.1a.789.789,0,0,0-1.148,0,.871.871,0,0,0,0,1.2L4.83,11.086a.792.792,0,0,0,.615.247.792.792,0,0,0,.615-.247L10.651,6.3a.871.871,0,0,0,0-1.2A.789.789,0,0,0,9.5,5.1L6.222,8.524V.81A.794.794,0,0,0,5.444,0Z"
      transform="translate(0)"
    />
    <path
      data-name="Path"
      d="M0,.667A.729.729,0,0,1,.778,0h9.333a.729.729,0,0,1,.778.667.729.729,0,0,1-.778.667H.778A.729.729,0,0,1,0,.667Z"
      transform="translate(0 12.667)"
    />
  </svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class UploadIcon extends Vue {}
</script>

<style></style>
